var map = {
	"./CRUDIE.gif": 87,
	"./CRUDIE.mp4": 3072,
	"./Editable.gif": 7857,
	"./Editable.mp4": 9791,
	"./ExpandableWithComp.gif": 3476,
	"./ExpandableWithCopm.mp4": 4468,
	"./Filter.gif": 5322,
	"./Filter.mp4": 490,
	"./SFE.gif": 3726,
	"./SFE.mp4": 7998,
	"./Sortable.gif": 5246,
	"./Sortable.mp4": 2023,
	"./Untitled design.gif": 5956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3085;